/* Core */
import { Dispatch, Middleware, UnknownAction } from "@reduxjs/toolkit";
import { createLogger } from "redux-logger";

const middleware: Middleware<object, any, Dispatch<UnknownAction>>[] = [];

// Adiciona o logger apenas em ambiente de desenvolvimento
if (process.env.NODE_ENV === "development") {
  const logger = createLogger({
    duration: true,
    timestamp: false,
    collapsed: true,
    colors: {
      title: () => "#139BFE",
      prevState: () => "#1C5FAF",
      action: () => "#149945",
      nextState: () => "#A47104",
      error: () => "#ff0005"
    },
    predicate: () => typeof window !== "undefined"
  });

  middleware.push(logger);
}

export { middleware };
